// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @module component
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Typography from '@material-ui/core/Typography'
// @component
import colors from '@bit/atd.web.colors'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: colors.black,
    fontSize: '26px',
    fontWeight: 500,
    lineHeight: '36px',
    padding: '16px 0 8px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '32px',
      lineHeight: '44px',
      padding: '24px 0 16px',
    },
  },
}))

const UserWelcomeMessage = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))
  const { data: user } = useQuery<GetUserQuery, GetUserQueryVariables>(
    GET_USER,
    {
      fetchPolicy: 'cache-first',
    },
  )

  /******************************************
   * RENDER
   ******************************************/

  return user?.user?.profile.firstName ? (
    // @todo (xerxes) we didn't reset the h1s, h2s etc properly
    // so they have all their default usr agent margins
    // this is causing the margin collapse problem in some areas
    // in some places we have added padding-top 1px to bypass the margin collapse issue
    // this should be looked at in more detail
    // Probably the best solution is to reset all teh H tags, then replace margins with padding
    <Typography className={classes.root}>
      Hi, <strong>{user.user.profile.firstName}</strong>.{' '}
      {isDesktop && 'Welcome back!'}
    </Typography>
  ) : (
    <></>
  )
}

export default UserWelcomeMessage
